import React from 'react';
import {
	HowDoesItWork,
	ProductInsurance,
	QuoteWithTestersPhoto,
	TestingHeader,
} from './components';
import {
	Awards,
	PaddingContainer,
	QuoteWithPhoto,
	Reviews,
	WeWorkWith,
} from '@components';
import { weWorkWithData } from '@store/TestingData';
import { colors } from '@styles/core-styles/theme';
import LukaszImage from '@images/staff/qa_lukasz.webp';
import JanisImage from '@images/staff/qa_janis.webp';
import { graphql, useStaticQuery } from 'gatsby';
import * as styles from './Testing.module.scss';
import useReviewsQuery from '@utils/hooks/useReviewsQuery';

export const Testing: React.FC = () => {
	const { directus } = useStaticQuery(graphql`
		query TestingReviewsQuery {
			directus {
				PageReviews(filter: { pageName: { _contains: "testing" } }) {
					Reviews {
						Reviews_id {
							quote
							reviewerName
							reviewerPosition
							link
							title
							logo {
								id
								imageFile {
									extension
									publicURL
									childImageSharp {
										gatsbyImageData
									}
								}
							}
						}
					}
				}
			}
		}
	`);
	const reviews = useReviewsQuery(directus);

	return (
		<>
			<TestingHeader />
			<QuoteWithTestersPhoto />
			<ProductInsurance />
			<PaddingContainer className="gray-bg">
				<div className={styles.quoteBox}>
					<QuoteWithPhoto image={LukaszImage} author="Łukasz, QA Tech Lead">
						<p className="font-600 font-size-22 pb-2">
							Why is QA this important?
						</p>
						<p className={styles.quoteContent}>
							It helps to meet the client&#8217;s demands and expectations.{' '}
							<span className="orange-font font-600">
								Thanks to QA, we can eliminate any problems that can occur at
								the early stage of building a project.
							</span>{' '}
							After manual and automated tests, the client is getting the
							product ready to use with a guarantee.
						</p>
					</QuoteWithPhoto>
				</div>
			</PaddingContainer>
			<HowDoesItWork />
			<PaddingContainer className="gray-bg">
				<div className={styles.quoteBox}>
					<QuoteWithPhoto
						image={JanisImage}
						author="Janis, QA"
						background={colors.yellowOrangeGradient}
						photoOnLeft
					>
						<p className={styles.quoteContent}>
							A well-prepared product concept, functionality, architecture, and
							test cases are the foundation for quality assurance even before
							software development starts. Thanks to the ISTQB certificate I
							could systemize my knowledge at the level of processes and
							techniques.
						</p>
					</QuoteWithPhoto>
				</div>
			</PaddingContainer>
			<WeWorkWith data={weWorkWithData} />
			{!!reviews.length && (
				<Reviews
					title="Our client says"
					reviews={reviews}
					maxWidth="1300px"
					titleClass="font-size-medium"
				/>
			)}
			<Awards />
		</>
	);
};
